import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import api from '@/api'

export const useLanguageStore = defineStore('language', () => {
  const currentLanguage = ref(localStorage.getItem('language') || 'tr')
  const languages = ref([])
  const defaultLanguage = ref('tr')

  const currentLanguageCode = computed(() => currentLanguage.value)

  async function loadLanguages() {
    try {
      const response = await api.get('/languages')
      languages.value = response.data
      // Find default language
      const defaultLang = response.data.find(lang => lang.is_default)
      if (defaultLang) {
        defaultLanguage.value = defaultLang.code
      }
      return response.data
    } catch (error) {
      console.error('Error loading languages:', error)
      return []
    }
  }

  function setLanguage(code) {
    currentLanguage.value = code
    localStorage.setItem('language', code)
  }

  function getLanguageId(code) {
    const lang = languages.value.find(l => l.code === code)
    return lang ? lang.id : null
  }

  function getLanguageCode(id) {
    const lang = languages.value.find(l => l.id === id)
    return lang ? lang.code : defaultLanguage.value
  }

  // Initialize on store creation
  loadLanguages()

  return {
    currentLanguage,
    languages,
    defaultLanguage,
    currentLanguageCode,
    loadLanguages,
    setLanguage,
    getLanguageId,
    getLanguageCode
  }
})









